// Reorder the book shelf in place: newest, oldest or alphabetical.
//
// The whole shelf is on one page when the sort control is enabled, so this
// sorts every book rather than just a page of them. The reader's choice is
// remembered in their browser. Without JavaScript the control stays hidden
// and the server-rendered order applies.

const STORAGE_KEY = "np-shelf-sort";

const ORDERS = {
    newest: (a, b) => b.date.localeCompare(a.date),
    oldest: (a, b) => a.date.localeCompare(b.date),
    title: (a, b) => a.title.localeCompare(b.title, undefined, { sensitivity: "base" })
};

// "The Hobbit - J R R Tolkien (1937)" sorts under H, as a library would file it
function titleKey(el) {
    const raw = (el.getAttribute("data-title") || "").trim();
    const name = raw.split(/\s+[-–—]\s+/)[0];
    return name.replace(/^(the|a|an)\s+/i, "").toLowerCase();
}

export default function shelfSort() {
    const control = document.querySelector("[data-shelf-sort]");
    const shelf = document.querySelector(".shelf");
    if (!control || !shelf) return;

    const books = [...shelf.children].map((el) => ({
        el,
        date: el.getAttribute("data-date") || "",
        title: titleKey(el)
    }));
    if (books.length < 2) return;

    const buttons = [...control.querySelectorAll("button[data-sort]")];

    const press = (mode) => buttons.forEach((b) => {
        b.setAttribute("aria-pressed", b.dataset.sort === mode ? "true" : "false");
    });

    const apply = (mode, remember) => {
        if (!ORDERS[mode]) return;
        const fragment = document.createDocumentFragment();
        books.slice().sort(ORDERS[mode]).forEach((b) => fragment.appendChild(b.el));
        shelf.appendChild(fragment);
        press(mode);
        if (remember) {
            try {
                localStorage.setItem(STORAGE_KEY, mode);
            } catch (e) {
                // Storage unavailable; the sort still works for this visit
            }
        }
    };

    buttons.forEach((b) => b.addEventListener("click", () => apply(b.dataset.sort, true)));
    control.hidden = false;

    let saved = null;
    try {
        saved = localStorage.getItem(STORAGE_KEY);
    } catch (e) {
        // Storage unavailable
    }

    if (saved && ORDERS[saved]) {
        apply(saved, false);
    } else {
        press(control.getAttribute("data-initial") || "newest");
    }
}
